module.exports = __webpack_public_path__ + "static/media/selec-nft-9.2974ce6a.png";